import SpinResultState from "../../core/src/states/SpinResultState";

export default class VendorSpinResultState extends SpinResultState {
    // checkAuto is removed
    protected init(): void {
        this.skipping = false;
        this.stopReels();
        this.setSkipWithSpace();
    }
}
